var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98902 5.9993C5.75585 5.99976 5.52987 5.91838 5.35033 5.7693L0.360516 1.7693C0.156716 1.59956 0.0285529 1.35565 0.00422288 1.09122C-0.0201072 0.826796 0.0613883 0.563515 0.230781 0.359299C0.400174 0.155082 0.643588 0.0266581 0.907476 0.0022784C1.17136 -0.0221013 1.43411 0.05956 1.63791 0.229299L5.98902 3.7093L10.3401 0.389299C10.4422 0.306233 10.5597 0.244202 10.6858 0.20677C10.8118 0.169338 10.9441 0.157244 11.0748 0.171184C11.2056 0.185123 11.3323 0.22482 11.4477 0.287993C11.5631 0.351167 11.6649 0.436572 11.7473 0.539299C11.8387 0.64212 11.9079 0.762747 11.9506 0.893621C11.9933 1.02449 12.0086 1.16279 11.9954 1.29986C11.9823 1.43692 11.9411 1.56979 11.8744 1.69015C11.8076 1.81051 11.7168 1.91575 11.6075 1.9993L6.61774 5.8293C6.43303 5.95481 6.21167 6.01467 5.98902 5.9993Z",
    fill: "#262E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.c0cb701533baff9f6239c6b96281b42e.svg";
export { ForwardRef as ReactComponent };